import logger from 'OK/logger';
import { addBlock } from 'OK/NewsFetchCoordinator';

var call2Enabled;

function _checkCall2() {
    if (!call2Enabled) {
        call2Enabled = !!document.getElementById('call2');
    }
}

function _sendPush(content, errCallback) {
    if (!content) {
        return;
    }

    import('OK/WebRTCUtils!').then(m => m && m.default || m).then(function(wrtc) {
        if (wrtc.isBrowserSupported()) {
            try {
                var msg = OK.util.parseJsonCorrected(content);
                if (msg) {
                    if (call2Enabled) {
                        import('OK/call2').then(m => m && m.default || m).then(function(call2) {
                            call2.onPush(msg);
                        });
                    } else {
                        import('OK/videochat/Chat').then(m => m && m.default || m).then(function(chat) {
                            chat.onPush(msg);
                        });
                    }
                }
            } catch(e) {
                errCallback && errCallback();
            }
        }
    });
}

function activatePush() {
    _checkCall2();
    addBlock('VCP'); // BlockId.VideoChatPush
    import('OK/VideoChatSound').then(m => m && m.default || m); // Нужно для прогрева звуков входящего звонка
}

function activateWebPush(element) {
    _checkCall2();
    if (window.history) {
        // Hide short link
        window.history.replaceState(null, '', '/');
    }

    var notification = element.getAttribute('data-notification'),
        alternativeLink = element.getAttribute('data-alternative-link');

    if (!notification) {
        if (alternativeLink) {
            if (window.navigateOnUrlFromJS) {
                navigateOnUrlFromJS(alternativeLink);
            }
        }
        return;
    }

    _sendPush(notification, function() {
        logger.error('videochat.webpush.error');
    });
}

function setNewContent(content) {
    _sendPush(content, function() {
        logger.error('videochat.push.error');
    });
}

export default { activatePush, activateWebPush, setNewContent };

export { activatePush, activateWebPush, setNewContent };
